import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components/macro';
import { SwiperSlide } from 'swiper/react';
import { Swiper } from 'swiper/types';
import { ImageType, PriceType } from '../../../hooks/api/queries/useProducts';
import { breakpoint } from '../../../styles/constants';
import { IMAGE_RATIOS } from '../../../styles/imageRatios';
import { Carousel } from '../../ui/carousel/Carousel';
import { CarouselPagination } from '../../ui/carousel/CarouselPagination';
import { WImage } from '../../ui/image/Image';
import { PriceImage } from '../../ui/image/PriceImage';

interface Props {
  images: ImageType[];
  imageSelected: number;
  setImageSelected: (e: number) => void;
  priceOverwrite?: PriceType;
}

export const MobileProductCarousel = ({
  images,
  imageSelected,
  setImageSelected,
  priceOverwrite,
}: Props) => {
  const [swiper, setSwiper] = useState<Swiper>();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      swiper?.realIndex !== imageSelected &&
      imageSelected >= 0 &&
      imageSelected < images.length
    )
      swiper?.slideToLoop(imageSelected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageSelected]);

  swiper?.on('slideChange', (swiper) => setImageSelected(swiper.realIndex));
  return (
    <FullWidthMobileOnly>
      <BackIcon icon={faChevronLeft} onClick={() => navigate(-1)} />
      <PositionPagination>
        <CarouselPagination swiper={swiper} images={images} />
      </PositionPagination>
      <Carousel setSwiper={setSwiper} loop loopAdditionSlides={0}>
        {images.map((image, index) => (
          <SwiperSlide key={`mobile-image-${image.id}-${index}`}>
            <ImageDiv>
              <PriceImage price={priceOverwrite} position={'top'} />
              <WImage image={image} background />
            </ImageDiv>
          </SwiperSlide>
        ))}
      </Carousel>
    </FullWidthMobileOnly>
  );
};

const FullWidthMobileOnly = styled.div`
  width: 100vw;
  margin-inline: 50%;
  transform: translateX(-50%);

  @media (min-width: ${breakpoint}) {
    display: none;
  }
`;

const BackIcon = styled(FontAwesomeIcon)`
  font-weight: 900;
  font-size: 0.875rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black};

  position: absolute;
  left: 0.75rem;
  top: 1.25rem;
  z-index: 2;

  @media (min-width: ${breakpoint}) {
    position: relative;
  }
`;

const PositionPagination = styled.div`
  position: absolute;
  z-index: 2;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0.625rem;
`;

const ImageDiv = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  img {
    width: 100%;
    aspect-ratio: ${IMAGE_RATIOS.PRODUCT_PAGE_MOBILE};
    object-fit: cover;
  }
`;
